/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamExamidLangsAvailable200,
  GetApiV1ExamExamidLangsAvailable401,
  GetApiV1ExamExamidLangsAvailable404,
  GetApiV1ExamExamidLangsAvailable500,
  GetApiV1ExamExamidLangsAvailablePathParams,
  GetApiV1ExamExamidLangsAvailableQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamExamidLangsAvailable.ts";
import { stringStringBaseDropDownListViewModelSchema } from "../stringStringBaseDropDownListViewModelSchema.ts";

export const getApiV1ExamExamidLangsAvailablePathParamsSchema = z.object({
  examId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamExamidLangsAvailablePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamExamidLangsAvailable200Schema = z.array(
  z.lazy(() => stringStringBaseDropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamExamidLangsAvailable200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamExamidLangsAvailable401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamidLangsAvailable401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamExamidLangsAvailable404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamidLangsAvailable404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamExamidLangsAvailable500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamidLangsAvailable500>;

export const getApiV1ExamExamidLangsAvailableQueryResponseSchema = z.lazy(
  () => getApiV1ExamExamidLangsAvailable200Schema,
) as unknown as ToZod<GetApiV1ExamExamidLangsAvailableQueryResponse>;
